module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAAXNSR0IB2cksfwAAAGNQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZmh03gAAACF0Uk5TAL//Wunb/utXO8qlFhioyDkcrMQ1N8apGt3jU1bl3P0nVin8PQAAAHVJREFUeJy9kNcOgCAMRaHuvff8/69UtCpNjY9eEiAnIZceIa5IkOIlsC8Ww7TAdlwKPT8I9yOKk/SBWV6UeK3qpsWmrh+0h+M0q27edBAJy0rxSfi34N5+xVyc/ByHilMqzwE1cagSg+I0lRgljqrUm3iIyg2ClATtegfYYwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/lay-path-hexagon.png
// module id = 842
// module chunks = 0